import api from "../../../api/api";
import API_URL from "../../../api/url";
import axios from 'axios';


const webEnquiryRequest = {
  // categoryList: (page, limit) => api.get(`${API_URL.BASEURL}${API_URL.getCategory}?page=${page}&limit=${limit}`),
  getEnquiryList: (values) => api.get(`${API_URL.BASEURL}${API_URL.webGetEnquiry}`, {
    params: {
      search: values?.search
    }
  }),

  postDeleteEnquiry: (id) => api.delete(`${API_URL.BASEURL}${API_URL.webEnquiryDelete}?id=${id}`),
  // postUpdateEnquiry: (values) => api.post(`${API_URL.BASEURL}${API_URL.webUpdateEnquiry}`, values),
  // getEnquiryDetail: (id) => api.get(`${API_URL.BASEURL}${API_URL.webEnquiryDetails}?id=${id}`),
  // createEnquiry: (values) => api.post(`${API_URL.BASEURL}${API_URL.webCreateEnquiry}`, values),
  
  // uploadImage: (formData) => {
  //   const token = localStorage.getItem("accesstoken");


  //   return api.post(
  //     `${API_URL.BASEURL}${API_URL.uploadImg}?moduleName=photos`,
  //     formData,
  //     {
  //       headers: {
  //         token: token ? `${token}` : "",
  //       },
  //     }
  //   );
  // }


};



export default webEnquiryRequest